// extracted by mini-css-extract-plugin
export default {"each-slide":"ImageSlide_each-slide__vS41f"};